import { createContext, useContext } from 'react';

type SidebarUIContextValue = {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
  mobileOpen: boolean;
  setMobileOpen: (value: boolean) => void;
};

export const SidebarUIContext = createContext<SidebarUIContextValue | null>(null);

export function useSidebarUI(): SidebarUIContextValue {
  const ctx = useContext(SidebarUIContext);
  if (!ctx) {
    return {
      collapsed: false,
      setCollapsed: () => {},
      mobileOpen: false,
      setMobileOpen: () => {},
    };
  }
  return ctx;
}
